<template>
  <div class="outer-page">
    <div class="sub-banner">
      <div class="bgImg">
        <div class="sub-txt">
          <h6>ONLINE  MALL</h6>
          <p>在线商城</p>
        </div>
      </div>
    </div>
    <div class="mall-qrcode">
      <div class="qrcode-item">
        <img src="/imgs/mall/douying.png" alt="douying">
        <p>抖音官方旗舰店</p>
      </div>
      <div class="qrcode-item">
        <img src="/imgs/mall/jingdong.png" alt="jingdong">
        <p>京东官方旗舰店</p>
      </div>
      <div class="qrcode-item">
        <img src="/imgs/mall/pdd.png" alt="pdd">
        <p>拼多多官方旗舰店</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "",
  data() {
    return {
      contactForm: {
        messagePeople: "",
        tel: "",
        messageContent: "",
      },
    };
  },
  computed: {

  },
  methods: {

  },
};
</script>

<style lang="less" scoped>
@import url("./index.less");
.mall-qrcode {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 50px 50px 80px 50px;
  gap:150px;
  .qrcode-item {
    text-align: center;

    img {
      width: 200px;
      height: 200px;
      margin-bottom: 10px;
    }

    p {
      font-weight: bold;
      font-size: 18px;
      color: #333;
    }
  }
}
</style>
